var render, staticRenderFns
import script from "./frozen_detail.vue?vue&type=script&lang=js&"
export * from "./frozen_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3954506a')) {
      api.createRecord('3954506a', component.options)
    } else {
      api.reload('3954506a', component.options)
    }
    
  }
}
component.options.__file = "found/views/fee/views/record_manage/discount_goods/form/frozen_detail.vue"
export default component.exports